export default class CiiRatingsData {
    constructor(requiredCii, aRating, bRating, cRating, dRating) {
        this.requiredCii = requiredCii;
        this.aRating = aRating;
        this.bRating = bRating;
        this.cRating = cRating;
        this.dRating = dRating;
    }
}



